import { useSelectPlCapsuleStreamState } from 'widgets/plCapsule/store/data/selectors';
import { buildPlData, PlData } from 'widgets/plCapsule/plCapsuleData';
import { usePlCapsuleConfigSlice } from 'widgets/plCapsule/store/config/configslice';
import { useContext, useMemo } from 'react';
import { useWidgetContext } from 'widgets/WidgetContext';
import AppContext from 'app/AppContext';
import { usePointedTime } from 'utils/components/TimeSeriesChart/timepoint';
import { getItemTimeOrLastItem } from 'utils/timeseries/timeSeriesUtils';

export function usePlCapsuleData() {
    const { config } = usePlCapsuleConfigSlice();
    const streamData = useSelectPlCapsuleStreamState();

    return useMemo(() => {
        return buildPlData(streamData?.data, config);
    }, [streamData, config]);
}

export function usePlPointedTimeData(data: PlData): {
    total: string;
    realised: string;
    realisedClass: string;
    unrealised: string;
} {
    const { widgetKey } = useWidgetContext();
    const time = usePointedTime('PlCapsulePointedTimeData' + widgetKey);
    return usePlDataAtTime(data, time);
}

export function usePlDataAtTime(
    data: PlData,
    time: number | undefined
): {
    total: string;
    realised: string;
    realisedClass: string;
    unrealised: string;
} {
    const { numberFormat } = useContext(AppContext);

    let item = data.lastNotNilItem;

    if (time !== undefined) {
        item = getItemTimeOrLastItem(data.plSeries, time);
    }

    const ret = {
        total: '',
        realised: '',
        unrealised: '',
        realisedClass: '',
    };

    if (item) {
        ret.total = numberFormat.n2(item.totalPnl);
        ret.realised = numberFormat.n2(item.realizedPnl);
        ret.unrealised = numberFormat.n2(item.unrealizedPnl);
    }

    ret.realisedClass = (item?.realizedPnl ?? 0) < 0 ? 'neg' : 'pos';

    ret.total = ret.total === '' ? '-' : ret.total;
    ret.realised = ret.realised === '' ? '-' : ret.realised;
    ret.unrealised = ret.unrealised === '' ? '-' : ret.unrealised;

    return ret;
}
